import { render, staticRenderFns } from "./ServicesItem.vue?vue&type=template&id=33016790&scoped=true&"
import script from "./ServicesItem.vue?vue&type=script&lang=js&"
export * from "./ServicesItem.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./ServicesItem.vue?vue&type=style&index=0&id=33016790&lang=sass&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "33016790",
  "2595ca2f"
  
)

export default component.exports